import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,
    services: {
        related_topics: {
            parameters: [
                {
                    name: 'topicid',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
